export default {
    pageTitle: 'Welcome to SMS Dashboard',

    // card titles
    status: 'Students By Status',
    partner: 'Alumni/Students by Partner Code',
    birthday: 'Birthday Students',
    news: 'News & Announcements',
    staffAbsence:'Staff Absences (next two weeks)',
    createNews: 'Add Announcement',
    editNews: 'Edit Announcement',
    newNews: 'Add new announcement',

    // Table Header
    name: 'Name',
    number: 'Student Number',
    dob: 'Birth Date',
    duration: 'Duration',
    durationValue: '{from} to {to} ({days} days)',

    // Message
    noBirthday: 'No birthday today.',
    noNews: 'No news found.',
    noAbsence: 'No absence found.',

    //
    title: 'Title',
    announcement: 'Announcement',
    announcementOnDashboard:'Show announcement on dashboard',
    expire: 'Expires',
    date: 'Date',
    newDate: 'Announcement Date',
    modifiedBy: 'Modified By:',
    modifiedDate: 'Modified Date:',
    createdBy: 'Created by:',
}